import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import registryCaseServices from '@/modules/RegistryModule/services/registryCaseServices'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { encoder } from '@/utils/encoder'

export class RegistryCaseGridDatasource<T> extends PaginatorLaboratoryDatasource<T> {
    constructor(laboratoryId: number) {
        super(registryCaseServices, laboratoryId)
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel = encoder.encode(encoder.parseBooleans(filterModel))
        return this.service.paginator(_filterModel, params, this.laboratoryId)
    }
}
